jQuery(document).ready(function ($) {
    const meetTheTeam = new Swiper('.js-meet-the-team', {
        loop: true,

        slidesPerView: 1,

        spaceBetween: 24,

        autoplay: true,
        delay: 6000,

        grabCursor: true,

        pagination: {
            el: '.meet-the-team__slider--pagination',

            bulletClass: 'pagination-bullet',
            bulletActiveClass: 'active',

            clickable: true,
        },

        slideClass: 'meet-the-team__member'
    });
});